import dashboard from './dashboard';
// import haunted from './haunted';
// import utilities from './utilities';
// import other from './other';
import learning from './learning';
import bank from './bank';
import data from './data';
import student from './murid';
import setting from './settings';
import payment from './payment';
import parent from './parent';
import archive from './archive';
import schedule from './schedule';
import studentaccounting from './studentaccounting';
import operasional from './operasional';
import programChange from './programChange';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    // haunted, // Event Halloween telah berakhir, di-hide dari sidebar admin (akses via URL /haunted-house tetap tersedia)
    student,
    parent,
    learning,
    bank,
    payment,
    studentaccounting,
    operasional,
    programChange,
    data,
    archive,
    schedule,
    setting
  ]
};

export default menuItems;
